const state = {
  lastPages: {},
};

const getters = {
  getLastPathByParent: (state) => (parent) => {
    return state.lastPages[parent]?.path;
  },
};

const actions = {
  rememberLastVisitedPage({ commit }, data) {
    commit('rememberLastVisitedPage', data);
  },
};

const mutations = {
  rememberLastVisitedPage(state, { parent, path, name }) {
    state.lastPages = {
      ...state.lastPages,
      [parent]: { path, name, time: new Date },
    };
  },

  clearLastVisitedPages(state) {
    state.lastPages = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
